import React from 'react';
import ProductDebtSoldScreen, {
  DebtSoldProduct,
} from 'shared/components/DebtSale/ProductDebtSoldScreen/ProductDebtSoldScreen';

export default function Page() {
  return (
    <ProductDebtSoldScreen
      product={DebtSoldProduct.Advance}
      settings={{
        pathname: '/accounts/advance-details',
        analyticsId: 'debt_sold_settingsClicked',
      }}
    />
  );
}
